(function () {
    'use strict';

    document.addEventListener('DOMContentLoaded', function () {
        const quizBlocks = document.querySelectorAll('.wp-block-ps-scenario-quiz, .wp-block-ps-isq-scenario-quiz, .ps-scenario-quiz-block-wrapper');

        quizBlocks.forEach(function (block, blockIdx) {
            initScenarioQuizBlock(block, blockIdx);
        });
    });

    // Pure JavaScript Fisher-Yates Shuffle
    function shuffleArray(array) {
        const arr = array.slice();
        for (let i = arr.length - 1; i > 0; i--) {
            const j = Math.floor(Math.random() * (i + 1));
            [arr[i], arr[j]] = [arr[j], arr[i]];
        }
        return arr;
    }

    function initScenarioQuizBlock(block, blockIdx) {
        const startScreen = block.querySelector('.ps-isq-view-start');
        const resultOpt1Screen = block.querySelector('.ps-isq-result-opt1');
        const resultOpt2Screen = block.querySelector('.ps-isq-result-opt2');
        const resultOpt3Screen = block.querySelector('.ps-isq-result-opt3');

        let scenarioContainer = block.querySelector('.ps-isq-dynamic-scenario-container');
        if (!scenarioContainer) {
            scenarioContainer = document.createElement('div');
            scenarioContainer.className = 'ps-isq-dynamic-scenario-container';
            scenarioContainer.setAttribute('role', 'region');
            scenarioContainer.setAttribute('aria-label', 'Quiz Questions');
            if (startScreen && startScreen.parentNode) {
                startScreen.parentNode.insertBefore(scenarioContainer, startScreen.nextSibling);
            } else {
                block.appendChild(scenarioContainer);
            }
        }

        function setQuizState(stateClass, announcementText = '') {
            const states = ['ps-isq-state-start', 'ps-isq-state-question', 'ps-isq-state-result'];

            states.forEach(cls => document.body.classList.remove(cls));
            document.body.classList.add(stateClass);

            states.forEach(cls => block.classList.remove(cls));
            block.classList.add(stateClass);

            if (scenarioContainer) {
                states.forEach(cls => scenarioContainer.classList.remove(cls));
                scenarioContainer.classList.add(stateClass);
            }

            if (announcementText) {
                let liveRegion = document.getElementById('ps-isq-sr-announcer');
                if (!liveRegion) {
                    liveRegion = document.createElement('div');
                    liveRegion.id = 'ps-isq-sr-announcer';
                    liveRegion.setAttribute('aria-live', 'polite');
                    liveRegion.setAttribute('aria-atomic', 'true');
                    liveRegion.style.position = 'absolute';
                    liveRegion.style.left = '-9999px';
                    liveRegion.style.width = '1px';
                    liveRegion.style.height = '1px';
                    liveRegion.style.overflow = 'hidden';
                    document.body.appendChild(liveRegion);
                }
                liveRegion.textContent = announcementText;
            }
        }

        setQuizState('ps-isq-state-start', 'Scenario quiz loaded. Press Start Quiz Now to begin.');

        [resultOpt1Screen, resultOpt2Screen, resultOpt3Screen].forEach(function (resEl, idx) {
            if (resEl) {
                resEl.style.display = 'none';
                resEl.setAttribute('role', 'region');
                resEl.setAttribute('aria-label', `Result Option ${idx + 1} Screen`);
            }
        });

        let scenariosData = [];
        const shouldShuffleQuestions = block.getAttribute('data-shuffle-questions') === 'true';
        const shouldShuffleAnswers = block.getAttribute('data-shuffle-answers') === 'true';

        try {
            let rawData = block.getAttribute('data-scenarios');
            if (rawData) {
                if (rawData.indexOf('&quot;') !== -1 || rawData.indexOf('&#039;') !== -1) {
                    const txt = document.createElement('textarea');
                    txt.innerHTML = rawData;
                    rawData = txt.value;
                }
                scenariosData = JSON.parse(rawData);
            }
        } catch (e) {
            console.warn('Could not parse scenario data', e);
        }

        let currentScenarioIndex = -1;
        let selectedAnswers = [];

        const startTriggerBtn = block.querySelector('.ps-isq-trigger-next') || block.querySelector('.wp-block-button__link');
        if (startTriggerBtn && startScreen) {
            startTriggerBtn.setAttribute('role', 'button');
            startTriggerBtn.setAttribute('tabindex', '0');
            startTriggerBtn.addEventListener('click', function (e) {
                e.preventDefault();
                if (scenariosData.length > 0) {
                    if (shouldShuffleQuestions) {
                        scenariosData = shuffleArray(scenariosData);
                    }
                    currentScenarioIndex = 0;
                    renderScenarioView();
                } else {
                    showResultScreen(2);
                }
            });
        }

        function renderScenarioView() {
            const currentStepNum = currentScenarioIndex + 1;
            const totalSteps = scenariosData.length;
            setQuizState('ps-isq-state-question', `Question ${currentStepNum} of ${totalSteps}`);

            if (startScreen) startScreen.style.display = 'none';
            [resultOpt1Screen, resultOpt2Screen, resultOpt3Screen].forEach(function (resEl) {
                if (resEl) resEl.style.display = 'none';
            });

            scenarioContainer.classList.remove('active');
            void scenarioContainer.offsetWidth;
            scenarioContainer.classList.add('active');

            const siteHeader = document.querySelector('header.site-header');
            if (siteHeader) {
                siteHeader.style.setProperty('display', 'none', 'important');
            }

            const scenario = scenariosData[currentScenarioIndex] || {};
            const total = scenariosData.length;

            const stepPalette = ['#FA96D2', '#FEC736', '#00AA28', '#14302B', '#fec736', '#6366F1', '#EC4899'];

            let badgesHtml = '<div class="ps-isq-badge-timeline" role="navigation" aria-label="Quiz Progress Timeline">';
            for (let i = 0; i < total; i++) {
                const stepLabel = String(i + 1).padStart(2, '0');
                const stepColor = stepPalette[i % stepPalette.length];

                let badgeClass = '';
                let badgeStyle = '';
                let badgeContent = '';
                let ariaLabel = `Step ${i + 1} of ${total}`;

                if (i < currentScenarioIndex) {
                    badgeClass = 'completed';
                    badgeStyle = `background-color: ${stepColor} ; color: #FFFFFF ;`;
                    badgeContent = `<span class="ps-isq-check-circle" aria-hidden="true"><svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none"><path d="M8.6 14.6L15.65 7.55L14.25 6.15L8.6 11.8L5.75 8.95L4.35 10.35L8.6 14.6ZM10 20C8.61667 20 7.31667 19.7375 6.1 19.2125C4.88333 18.6875 3.825 17.975 2.925 17.075C2.025 16.175 1.3125 15.1167 0.7875 13.9C0.2625 12.6833 0 11.3833 0 10C0 8.61667 0.2625 7.31667 0.7875 6.1C1.3125 4.88333 2.025 3.825 2.925 2.925C3.825 2.025 4.88333 1.3125 6.1 0.7875C7.31667 0.2625 8.61667 0 10 0C11.3833 0 12.6833 0.2625 13.9 0.7875C15.1167 1.3125 16.175 2.025 17.075 2.925C17.975 3.825 18.6875 4.88333 19.2125 6.1C19.7375 7.31667 20 8.61667 20 10C20 11.3833 19.7375 12.6833 19.2125 13.9C18.6875 15.1167 17.975 16.175 17.075 17.075C16.175 17.975 15.1167 18.6875 13.9 19.2125C12.6833 19.7375 11.3833 20 10 20ZM10 18C12.2333 18 14.125 17.225 15.675 15.675C17.225 14.125 18 12.2333 18 10C18 7.76667 17.225 5.875 15.675 4.325C14.125 2.775 12.2333 2 10 2C7.76667 2 5.875 2.775 4.325 4.325C2.775 5.875 2 7.76667 2 10C2 12.2333 2.775 14.125 4.325 15.675C5.875 17.225 7.76667 18 10 18Z" fill="white"/></svg></span>`;
                    ariaLabel += `, Completed`;
                } else if (i === currentScenarioIndex) {
                    badgeClass = 'active';
                    badgeStyle = `background-color: ${stepColor} ;`;
                    badgeContent = stepLabel;
                    ariaLabel += `, Current Step`;
                } else {
                    badgeClass = 'upcoming';
                    badgeStyle = `background-color: #E2E8F0 ; color: #1E293B ;`;
                    badgeContent = stepLabel;
                    ariaLabel += `, Upcoming`;
                }

                badgesHtml += `<div class="ps-isq-badge ${badgeClass}" style="${badgeStyle}" role="img" aria-label="${ariaLabel}">${badgeContent}</div>`;

                if (i < total - 1) {
                    const lineColor = i < currentScenarioIndex ? stepColor : '#CBD5E1';
                    badgesHtml += `<div class="ps-isq-timeline-connector" style="background-color: ${lineColor};" aria-hidden="true"></div>`;
                }
            }
            badgesHtml += '</div>';

            const questionNum = String(currentScenarioIndex + 1).padStart(2, '0');
            const questionImg = scenario.image || '';
            const cardBgColor = scenario.cardBgColor || '#002828';
            const textColor = scenario.textColor || '#FFFFFF';
            const siteLogoUrl = (typeof psQuizSettings !== 'undefined' && psQuizSettings.logoUrl)
                ? psQuizSettings.logoUrl
                : '';

            const logoHtml = siteLogoUrl
                ? `<div class="ps-isq-logo-wrapper"><a href="/" aria-label="Home"><img src="${siteLogoUrl}" alt="Site Logo" class="ps-isq-logo"/></a></div>`
                : '';

            const fallbackBg = scenario.optionBgColor || '#FFFFFF';
            const fallbackText = scenario.optionTextColor || '#002828';

            let rawOptions = [
                {
                    optNum: 1,
                    text: scenario.option1Text,
                    bgColor: scenario.option1BgColor || fallbackBg,
                    textColor: scenario.option1TextColor || fallbackText
                },
                {
                    optNum: 2,
                    text: scenario.option2Text,
                    bgColor: scenario.option2BgColor || fallbackBg,
                    textColor: scenario.option2TextColor || fallbackText
                },
                {
                    optNum: 3,
                    text: scenario.option3Text,
                    bgColor: scenario.option3BgColor || fallbackBg,
                    textColor: scenario.option3TextColor || fallbackText
                }
            ].filter(item => !!item.text);

            if (shouldShuffleAnswers) {
                rawOptions = shuffleArray(rawOptions);
            }

            const optionsHtml = rawOptions.map(opt => `
                <div class="ps-isq-option-item" role="radio" aria-checked="false" tabindex="0" data-opt="${opt.optNum}" style="background-color: ${opt.bgColor}; color:${opt.textColor};">
                    <div class="ps-isq-radio-dot" aria-hidden="true"></div>
                    <span style="color: ${opt.textColor};">${opt.text}</span>
                </div>
            `).join('');

            scenarioContainer.innerHTML = `
                <div class="ps-isq-question-wrapper" role="region" aria-label="Question ${currentStepNum} of ${totalSteps}">
                    <div class="ps-isq-top-progress-bar">
                        ${logoHtml}
                        ${badgesHtml}
                    </div>

                    <div class="ps-isq-card-grid">
                        <div class="ps-isq-card-image-wrap">
                            <img src="${questionImg}" alt="${scenario.title || 'Scenario Illustration'}" class="ps-isq-card-img" />
                        </div>

                        <div class="ps-isq-card-content-wrap" style="background-color: ${cardBgColor}; color: ${textColor};">
                            <div class="ps-isq-card-header-num" style="color: ${textColor}; opacity: 0.9;" aria-hidden="true">${questionNum}</div>
                            ${scenario.subtitle ? `<div class="ps-isq-card-subtitle" style="color: ${textColor}; opacity: 0.95;">${scenario.subtitle}</div>` : ''}
                            <div class="ps-isq-card-description" style="color: ${textColor}; opacity: 0.88;">${scenario.question || ''}</div>
                            <h2 class="ps-isq-card-title" style="color: ${textColor};" id="quiz-question-title">${scenario.title || 'Scenario Question'}</h2>

                            <div class="ps-isq-options-list" role="radiogroup" aria-labelledby="quiz-question-title">
                                ${optionsHtml}
                            </div>

                            <div class="ps-isq-card-footer">
                                <button class="ps-isq-continue-btn" disabled aria-disabled="true">
                                    <span>Continue</span>
                                    <span aria-hidden="true">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="26" height="16" viewBox="0 0 26 16" fill="none">
                                        <path d="M22.175 9H0V7H22.175L16.575 1.4L18 0L26 8L18 16L16.575 14.6L22.175 9Z" fill="white"/>
                                        </svg>
                                    </span>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            `;

            let tempChosenOpt = null;
            const optionItems = scenarioContainer.querySelectorAll('.ps-isq-option-item');
            const continueBtn = scenarioContainer.querySelector('.ps-isq-continue-btn');

            function selectOption(optItem) {
                optionItems.forEach(el => {
                    el.classList.remove('selected');
                    el.setAttribute('aria-checked', 'false');
                });
                optItem.classList.add('selected');
                optItem.setAttribute('aria-checked', 'true');
                tempChosenOpt = parseInt(optItem.getAttribute('data-opt'), 10);
                if (continueBtn) {
                    continueBtn.removeAttribute('disabled');
                    continueBtn.setAttribute('aria-disabled', 'false');
                }
            }

            optionItems.forEach(function (optItem) {
                optItem.addEventListener('click', function () {
                    selectOption(optItem);
                });

                optItem.addEventListener('keydown', function (e) {
                    if (e.key === 'Enter' || e.key === ' ') {
                        e.preventDefault();
                        selectOption(optItem);
                    }
                });
            });

            if (continueBtn) {
                continueBtn.addEventListener('click', function () {
                    if (tempChosenOpt === null) return;
                    selectedAnswers[currentScenarioIndex] = tempChosenOpt;

                    if (currentScenarioIndex < scenariosData.length - 1) {
                        currentScenarioIndex++;
                        renderScenarioView();
                    } else {
                        calculateAndShowResult();
                    }
                });

                continueBtn.addEventListener('keydown', function (e) {
                    if (e.key === 'Enter' || e.key === ' ') {
                        if (!continueBtn.hasAttribute('disabled')) {
                            e.preventDefault();
                            continueBtn.click();
                        }
                    }
                });
            }
        }

        function calculateAndShowResult() {
            let counts = { 1: 0, 2: 0, 3: 0 };
            selectedAnswers.forEach(function (optNum) {
                if (counts[optNum] !== undefined) counts[optNum]++;
            });

            let winningOption = 2;
            if (counts[1] > counts[2] && counts[1] > counts[3]) {
                winningOption = 1;
            } else if (counts[2] > counts[1] && counts[2] >= counts[3]) {
                winningOption = 2;
            } else if (counts[3] > counts[1] && counts[3] > counts[2]) {
                winningOption = 3;
            } else {
                winningOption = 2;
            }

            showResultScreen(winningOption);
        }

        function showResultScreen(winningOption) {
            setQuizState('ps-isq-state-result', 'Quiz completed. Loading your result screen.');

            if (startScreen) startScreen.style.display = 'none';
            if (scenarioContainer) scenarioContainer.style.display = 'none';

            const siteHeader = document.querySelector('header.site-header');
            if (siteHeader) {
                siteHeader.style.removeProperty('display');
            }

            [resultOpt1Screen, resultOpt2Screen, resultOpt3Screen].forEach(function (resEl) {
                if (resEl) resEl.style.display = 'none';
            });

            let activeResult = null;
            if (winningOption === 1 && resultOpt1Screen) {
                activeResult = resultOpt1Screen;
            } else if (winningOption === 3 && resultOpt3Screen) {
                activeResult = resultOpt3Screen;
            } else if (resultOpt2Screen) {
                activeResult = resultOpt2Screen;
            }

            if (activeResult) {
                activeResult.style.display = 'block';
            }
        }
    }

    document.addEventListener('keydown', function (e) {
        const triggerBtn = e.target.closest('.ps-isq-trigger-next');
        if (triggerBtn && (e.key === 'Enter' || e.key === ' ')) {
            e.preventDefault();
            const link = triggerBtn.querySelector('a') || triggerBtn;
            link.click();
        }
    });
})();

document.addEventListener("DOMContentLoaded", () => {
    document.querySelectorAll(
        ".ps-isq-col-images-left, .ps-isq-col-images-right"
    ).forEach((container) => {
        if (container.dataset.duplicated === "true") return;

        const originalImages = Array.from(
            container.querySelectorAll(":scope > figure.wp-block-image")
        ).slice(0, 3);

        if (originalImages.length !== 3) return;

        for (let i = 0; i < 2; i++) {
            originalImages.forEach((figure) => {
                const clone = figure.cloneNode(true);
                clone.setAttribute('aria-hidden', 'true');
                const img = clone.querySelector('img');
                if (img) {
                    img.setAttribute('alt', '');
                    img.setAttribute('loading', 'lazy');
                }
                container.appendChild(clone);
            });
        }

        container.dataset.duplicated = "true";
    });
});